import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FlightClassIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FlightClassGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.0962 22.0005H9.14141C7.02102 22.0005 5.11121 20.0549 4.97155 17.751L4.41289 8.54409C4.39448 8.23878 4.62671 7.97569 4.93256 7.95728C5.23301 7.92913 5.50097 8.17165 5.51937 8.47696L6.07803 17.6839C6.19279 19.5742 7.78484 20.8918 9.14141 20.8918H14.0962C14.4026 20.8918 14.6505 21.1398 14.6505 21.4462C14.6505 21.7526 14.4026 22.0005 14.0962 22.0005Z"
        fill="#696969"
      />
      <path
        d="M10.315 7.12906C8.90106 7.12906 7.75073 5.97927 7.75073 4.56532C7.75073 3.15136 8.90106 2.00049 10.315 2.00049C11.729 2.00049 12.8793 3.15136 12.8793 4.56532C12.8793 5.97927 11.729 7.12906 10.315 7.12906ZM10.315 3.10913C9.51222 3.10913 8.85937 3.76198 8.85937 4.56532C8.85937 5.36756 9.51222 6.02041 10.315 6.02041C11.1178 6.02041 11.7707 5.36756 11.7707 4.56532C11.7707 3.76198 11.1178 3.10913 10.315 3.10913Z"
        fill="#696969"
      />
      <path
        d="M17.8298 21.9842C17.3334 21.9842 16.8375 21.7959 16.4591 21.418L14.7409 19.6998H10.7048C8.87345 19.6998 7.38371 18.2101 7.38371 16.3782V10.5492C7.38371 9.12116 8.54541 7.95947 9.97344 7.95947C10.505 7.95947 11.0193 8.12295 11.4599 8.43259C11.5244 8.45533 11.7127 8.55602 11.8849 8.72816L13.6929 10.5362H16.0731C17.073 10.5362 17.8861 11.3493 17.8861 12.3486C17.8861 13.3479 17.073 14.161 16.0731 14.161H13.5863C13.2366 14.161 12.8923 14.1047 12.5632 13.9953V14.987C12.5632 15.4439 12.9351 15.8164 13.3919 15.8164H15.5102C16.0239 15.8164 16.5078 16.0145 16.8727 16.3761L19.1934 18.6692C19.5626 19.0351 19.7672 19.5234 19.7683 20.0431C19.7694 20.5627 19.568 21.051 19.2004 21.418C18.8226 21.7959 18.3262 21.9842 17.8298 21.9842ZM9.97343 9.0681C9.15656 9.0681 8.49235 9.73285 8.49235 10.5492V16.3782C8.49235 17.5984 9.48461 18.5912 10.7048 18.5912H14.9705C15.1177 18.5912 15.2585 18.6496 15.3624 18.7536L17.243 20.6342C17.5672 20.9579 18.0934 20.9557 18.4166 20.6342C18.5736 20.4772 18.6602 20.2682 18.6596 20.0452C18.6591 19.8232 18.5719 19.6143 18.4139 19.4573L16.0937 17.1642C15.9373 17.0105 15.73 16.925 15.5102 16.925H13.3919C12.3239 16.925 11.4545 16.0556 11.4545 14.987V13.0999C11.4545 12.8931 11.5698 12.7037 11.7533 12.6084C11.9379 12.512 12.1593 12.5261 12.3282 12.6463C12.705 12.9115 13.1397 13.0523 13.5863 13.0523H16.0731C16.4613 13.0523 16.7774 12.7361 16.7774 12.3485C16.7774 11.961 16.4613 11.6448 16.0731 11.6448H13.4634C13.3162 11.6448 13.1754 11.5864 13.0715 11.4824L11.101 9.51198C11.0599 9.47084 10.9987 9.43294 10.9029 9.38639C10.5694 9.16228 10.276 9.0681 9.97343 9.0681Z"
        fill="#696969"
      />
    </svg>
  );
};

export default FlightClassIcon;
